<template>
  <footer class="footer px-4">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted">
          © 2006-{{year}} <a href="https://www.poliglotiki.ru/" class="font-weight-bold ml-1" target="_blank">ПОЛИГЛОТИКИ</a> - Сеть детских языковых центров. Онлайн-платформа обучения детей от 1 года до 12 лет.
          <br><small>© Дизайн Creative Tim & Binar Code</small>
        </div>
      </div>
      <div class="col-lg-6">
        <ul class="nav nav-footer justify-content-center justify-content-lg-end">
          <li class="nav-item">
            <a href="https://www.poliglotiki.ru/about.html" class="nav-link" target="_blank">О нас</a>
          </li>
          <li class="nav-item">
            <a href="https://www.poliglotiki.ru/unikalnaya_metodika.html" class="nav-link" target="_blank">Уникальная методика</a>
          </li>
          <li class="nav-item">
            <a href="https://www.poliglotiki.ru/programs.html" class="nav-link" target="_blank">Программы обучения</a>
          </li>
          <li class="nav-item">
            <a href="https://www.poliglotiki.ru/index_all" class="nav-link" target="_blank">Наши центры</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
